import React, { useEffect } from 'react'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { connect } from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";


// components
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";
import { GenericTableButton } from "../../../components/buttons/buttonsActions";
import { ConfirmDelete } from "../../../components/confirmAlert/ConfirmDelete";
import FbChildPathFilters from "./_filters";
import FbChildPathForm from "./_form";

// labels
import {
    error,
    LIST, NO_DATA_FOUND
} from "../../../components/i18n/i18n";
import { TT_DELETE, TT_EDIT } from "../../../components/i18n/toolTips";


// actions
import {changeListItem, setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import { setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { genericActions } from "../../../redux/actions/generics/GenericActions";


// services
import {fbChildPathService} from "../../../jwt/_services/firebase/fbChildPathService";


const FbChildPathList = props => {
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps


    // asignar los valores por default del filtro
    useEffect( () => {
        if( filter)
            return

        props.setFilter( { code : null , url : null } )
    }, [  ])



    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericActions.search(fbChildPathService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);



    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };


    const confirmDelete = (data) => {
        return ConfirmDelete({ remove : genericActions.remove , data : data, fbDataBaseId :  '', service: fbChildPathService } );
    };

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(FbChildPathForm , { data, Form: FbChildPathForm })
    }

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>


    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'code',
        text: 'Código'
    }, {
        dataField: 'url',
        text: 'Url'
    }, {
        dataField: 'codeDatabase',
        text: 'Base de datos',
        headerStyle: {width: '150px'},
    }, {
        dataField: 'attributeIdentifier',
        text: 'Atributos',
        headerStyle: {width: '50px'},
    }, {
        isDummyField: true,
        text: 'Acción',
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '150px'},
        formatter: actionsFormatter
    }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <FbChildPathFilters />

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
})
export default connect(mapStateToProps, mapActionsToProps)(FbChildPathList)